module.exports = __webpack_public_path__ + "static/mobile-spot-workers-hdr-fe426047e20e358daff64635d30996bc.png";